import React from 'react';
import { Navbar } from 'react-bootstrap';
import cn from 'classnames';
import T from 'prop-types';
import routes from '../../../../../routes/constants';
import text from '../../../../../text';
var MarketingNav = function(props) {
    var className = props.className;
    return /*#__PURE__*/ React.createElement(Navbar.Collapse, {
        className: cn('MarketingNav', className)
    }, /*#__PURE__*/ React.createElement("ul", {
        className: "navbar-nav navigation"
    }, /*#__PURE__*/ React.createElement("li", {
        className: "MarketingNav-Item"
    }, /*#__PURE__*/ React.createElement("a", {
        href: process.env.LARKI_MARKETING_URL + '/products'
    }, /*#__PURE__*/ React.createElement("div", {
        className: "MarketingNav-Link"
    }, text('products')))), /*#__PURE__*/ React.createElement("li", {
        className: "MarketingNav-Item"
    }, /*#__PURE__*/ React.createElement("a", {
        href: process.env.LARKI_MARKETING_URL + '/pricing'
    }, /*#__PURE__*/ React.createElement("div", {
        className: "MarketingNav-Link"
    }, text('pricing')))), /*#__PURE__*/ React.createElement("li", {
        className: "MarketingNav-Item"
    }, /*#__PURE__*/ React.createElement("a", {
        href: process.env.LARKI_MARKETING_URL + '/about'
    }, /*#__PURE__*/ React.createElement("div", {
        className: "MarketingNav-Link"
    }, text('aboutUs')))), /*#__PURE__*/ React.createElement("li", {
        className: "MarketingNav-Item"
    }, /*#__PURE__*/ React.createElement("a", {
        href: process.env.LARKI_MARKETING_URL + '/contact-us'
    }, /*#__PURE__*/ React.createElement("div", {
        className: "MarketingNav-Link"
    }, text('contactUs')))), /*#__PURE__*/ React.createElement("li", {
        id: "login-item",
        className: "MarketingNav-Item"
    }, /*#__PURE__*/ React.createElement("a", {
        href: routes.login
    }, /*#__PURE__*/ React.createElement("div", {
        className: "MarketingNav-Link"
    }, text('login'))))));
};
MarketingNav.propTypes = {
    className: T.string
};
export default MarketingNav;
